import React, { useState, useEffect } from 'react';
var TouristScrollToTop = function (_a) {
    var Icon = _a.Icon;
    var _b = useState(false), isVisible = _b[0], setIsVisible = _b[1];
    useEffect(function () {
        document.addEventListener('scroll', function () {
            toggleVisibility();
        });
    }, []);
    var toggleVisibility = function () {
        if (window.pageYOffset > 300) {
            setIsVisible(true);
        }
        else {
            setIsVisible(false);
        }
    };
    var scrollToTop = function () {
        window.scrollTo({
            top: 0,
            behavior: 'smooth',
        });
    };
    return (React.createElement(React.Fragment, null, isVisible && (React.createElement("div", { className: "tourist-top", onClick: scrollToTop },
        React.createElement(Icon, { type: "up" })))));
};
export default TouristScrollToTop;
//# sourceMappingURL=index.js.map